import React from 'react';
import { Navbar, Welcome } from '../../components';
import styled from 'styled-components';
import HeaderBackground from '../../assets/images/welcome.jpg';

const Header = () => {
  return (
    <StyledHeader>
      <Navbar />
      <Welcome />
    </StyledHeader>
  );
};

const StyledHeader = styled('section')`
  background-image: url(${HeaderBackground});
  background-repeat: no-repeat;
  background-size: cover;
  @media (max-width: 1135px) {
    background-position: center;
  }
`;

export default Header;
